'use client';
import { getHotkeyHandler } from './parseHotkeys.js';
import { useWindowEvent } from '../useWindowEvent/useWindowEvent.js';

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable) {
    if (triggerOnContentEditable === void 0) triggerOnContentEditable = false;
    if (_instanceof(event.target, HTMLElement)) {
        if (triggerOnContentEditable) {
            return !tagsToIgnore.includes(event.target.tagName);
        }
        return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
    }
    return true;
}
var useHotkeys = function(hotkeys, tagsToIgnore, triggerOnContentEditable) {
    if (tagsToIgnore === void 0) tagsToIgnore = [
        "INPUT",
        "TEXTAREA",
        "SELECT"
    ];
    if (triggerOnContentEditable === void 0) triggerOnContentEditable = false;
    useWindowEvent("keydown", function(event) {
        if (shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)) {
            getHotkeyHandler(hotkeys)(event);
        }
    });
};

export { useHotkeys };
